/**
 * A unidade do fluxo interno.
 *
 * O app interno nunca foi multi-unidade: todo agendamento criado pela
 * secretária, pelo agendador externo ou pelo totem nasce com
 * `unitId: 'unit-1'` — a unidade que o `AuthContext` cria junto da clínica.
 * Só o portal do paciente é multi-unidade de verdade.
 *
 * Isso importa pro expediente por médico (spec 010): `unitSchedules` é
 * indexado por unidade, e ler a unidade do PERFIL daria o horário de um
 * lugar onde não existe agendamento nenhum. Enquanto a fase 0 não vier,
 * a resposta certa é esta constante — e ela existe pra que a fase 0 tenha
 * um lugar só pra mudar.
 */
export const INTERNAL_UNIT_ID = 'unit-1';
